import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { finalize } from 'rxjs';

import { ErrorService } from 'src/app/core/services/error.service';
import { Gender } from 'src/app/core/enums/gender';
import { PairingService } from 'src/app/core/services/pairing.service';
import { Patient } from 'src/app/core/entities/patient.entity';
import { SpinnerService } from 'src/app/core/services/spinner.service';

@Component({
  selector: 'app-pairing-patient-modal',
  templateUrl: './pairing-patient-modal.component.html',
  styleUrls: ['./pairing-patient-modal.component.css'],
})
export class PairingPatientModalComponent implements OnInit {
  @Input() public patient: Patient = new Patient();
  public gender = Gender;

  constructor(
    public activeModal: NgbActiveModal,
    private pairingService: PairingService,
    private spinnerService: SpinnerService,
    private errorService: ErrorService
  ) {}

  ngOnInit(): void {}

  confirmPairing(): void {
    this.spinnerService.show();
    this.pairingService
      .acceptRequest(this.patient.pairing.getId())
      .pipe(
        finalize(() => {
          this.spinnerService.hide();
        })
      )
      .subscribe({
        next: (res) => {
          this.activeModal.close(this.patient);
        },
        error: (err) => {
          this.errorService.addError(err);
          this.errorService.show();
        },
      });
  }
}
